import React, { useContext } from 'react'
import EditCtrl from '../cmp/EditCtrl.js'
import icon from '../icons.svg'

import {dataContext,localestr,toText,isValidDate} from '../utils.js'

function RepForm496({data=undefined,actions}){
    let wndData=''
    let content=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const context=useContext(dataContext)
    const loaddat=context.loaddata
    const msg=context.msg
    const inputRange=context.inputRange
    const OpenTabObject=context.OpenTabObject
    const setLoginData=context.setLoginData

    let from=new Date()
    from.setHours(0,0,0,0)
    let to=new Date()
    to.setHours(23,59,59,999)

    if (wndData.from) from=wndData.from
    if (wndData.to) to=wndData.to

    let check=0
    if (wndData.check) check=wndData.check

    function range(frm,to_){
        let froml=from
        let tol=to
        if (isValidDate(frm)) froml=frm
        if (isValidDate(to_)) tol=to_
        if (froml>tol) {
            msg(localestr('Не правильний діапазон дат'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        setWndData({...wndData,from:froml,to:tol})
    }

    function set_fiscal(d){
        if (d&&d.device&&d.device&&parseInt(d.device.value)<4) {
            msg(localestr('Не правильний тип пристрою'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        setWndData({...wndData,fiscal:d})
    }

    function loadData(d){
        if(d){
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='UsrChoise') {setLoginData(d);return}

            let data=[]
            for(let i=0;i<d.data.length;i++){
                const item={nom:i+1,date:new Date(d.data[i].date).toLocaleDateString(),kind:d.data[i].kind,in_date:d.data[i].in_date?new Date(d.data[i].in_date).toLocaleDateString():'',in_num:d.data[i].in_num,
                    counterpartie:d.data[i].counterpartie,sum_d:d.data[i].sum_d?parseFloat(d.data[i].sum_d).toFixed(2):'',sum_c:d.data[i].sum_c?parseFloat(d.data[i].sum_c).toFixed(2):'',obj:{type:d.data[i].type,id:d.data[i].id}}
                data.push(item)
            }
            const caption=d.caption
            setWndData({...wndData,content:{caption,data}})

        } else {
            let froml=from.toISOString().substring(0,19)+'Z'
            let tol=to.toISOString().substring(0,19)+'Z'
            let tz=to.getTimezoneOffset()
            if(tz<0) tz='%2B0'+(tz/-60)+':00'
            else  tz='-0'+(tz/60)+':00'
            if(!wndData.fiscal){msg(localestr('Не вибрано ПРРО'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            loaddat('action=repForm496&data='+JSON.stringify({from:froml,to:tol,tz,fiscal:wndData.fiscal.id,check}),null,(dt)=>{loadData(dt)})
        }
    }

    function specification(obj){
        if(!obj) return
        OpenTabObject(obj.type,obj.id)
    }

    if(wndData.content){
        const items=wndData.content.data.map((el,idx)=>{
            return <tr tabIndex='0' key={idx} onDoubleClick={()=>specification(el.obj)}>
                <td style={{textAlign:'right'}}>{el.nom}</td>
                <td style={{textAlign:'center'}}>{el.date}</td>
                <td>{el.kind}</td>
                <td style={{textAlign:'center'}}>{el.in_date}</td>
                <td style={{textAlign:'center'}}>{el.in_num}</td>
                <td>{el.counterpartie}</td>
                <td style={{textAlign:'right'}}>{el.sum_d}</td>
                <td style={{textAlign:'right'}}>{el.sum_c}</td>
                <td style={{textAlign:'right'}}>{el.note}</td>
            </tr>
        })
        content=<><h6 style={{margin:'0 0 0 70%',fontSize:'8pt'}}>Додаток <br />до Порядку ведення обліку товарних запасів для фізичних осіб - підприємців, у тому числі платників єдиного податку (пункт 2 розділу I)</h6>
            <h3 style={{fontSize:'12pt',textAlign:'center'}}>ФОРМА <br />ведення обліку товарних запасів</h3>
            <h3 style={{margin:'0',fontSize:'12pt',textAlign:'center',borderBottom:'1px solid #000',minWidth:'20cm'}}>{wndData.content.caption}</h3>
            <h6 style={{margin:'0 0 2mm',fontSize:'8pt',textAlign:'center'}}>(дані ФОП відповідно до пункту 2 розділу II цього Порядку)</h6>
        <table className='rep_table rep_10pt'>
            <thead><tr>
                <th rowSpan={2}>№<br/>з/п</th>
                <th rowSpan={2}>Дата<br/>внесення<br/>запису</th>
                <th colSpan={4}>Реквізити первинного документа, що підтверджує надходження або вибуття товару<br/>(підпункт 3 пункту 3 розділу II цього Порядку)</th>
                <th colSpan={2}>Загальна вартість товарів за первинним документом, грн</th>
                <th rowSpan={2}>Примітки<br/>(підпункт 6<br/>пункту 3<br/>розділу II<br/>цього Порядку)</th>
                </tr><tr>
                <th>Вид</th>
                <th>Дата</th>
                <th>№</th>
                <th>Постачальник (продавець, виробник)<br/>або отримувач товару</th>
                <th>Надходження товару<br/>(придбання, повернення<br/>товару від покупця, або<br/>внутрішнє переміщення)<br/>(підпункт 4 пункту 3<br/>розділу II цього Порядку)</th>
                <th>Вибуття товару (продаж<br/>товарів в безготівковій<br/>формі, внутрішнє<br/>переміщення, знищення<br/>або втрата, повернення<br/>товару постачальнику,<br/>використання на власні<br/>потреби)<br/>(підпункт 5 пункту 3<br/>розділу II цього Порядку)</th>
                </tr><tr>
                <th>1</th>    
                <th>2</th>    
                <th>3</th>    
                <th>4</th>    
                <th>5</th>    
                <th>6</th>    
                <th>7</th>    
                <th>8</th>    
                <th>9</th>    
                </tr></thead>
            <tbody>{items}</tbody>
        </table>
        </>
    }
    
    //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+
    let btn2=null
    if(content) {
        btn2=<div className='no-print' style={{position:'absolute',top:'5px',right:'5px'}} onClick={e=>window.print()}><img style={{width:'24px',height:'24px'}} src={icon+'#b503'} alt=''/></div>
    }

    return(
        <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'row'}}>
            <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'column'}}>
                <div className='toolBar no-print'>
                    <div tabIndex='0' onClick={()=>{loadData()}} onKeyUp={(e)=>{if(e.key === 'Enter') loadData()}}
                        style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'95px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
                        <img style={{width:'12px',height:'24px',padding:'2px',verticalAlign:'middle'}} src={icon+'#run'} alt={localestr('Вивести')} />&nbsp;
                        {localestr('Вивести')}
                    </div>
                    <div tabIndex='0' onClick={()=>{inputRange(from,to,range)}} onKeyUp={(e)=>{if(e.key === 'Enter') range()}}
                        style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'192px',padding:'0px 2px 0 6px',userSelect:'none',cursor:'pointer',color:'#FFF',background:'url('+icon+'#btn185v) no-repeat',backgroundSize:'192px 30px'}}>
                        {toText(from)}-{toText(to)}
                        <img style={{width:'24px',height:'24px',verticalAlign:'middle'}} src={icon+'#cal_w'} alt={localestr('Інтервал дат')} />
                    </div>
                    <div style={{flexGrow:'10'}}></div>
                    <EditCtrl Capt={localestr('Для ПРРО')} Value={wndData.fiscal} typeVal={'catDevices'} setVal={set_fiscal} width1='114' width2='226' />
                    <EditCtrl Capt={localestr('Включати фіскальні чеки')} Value={wndData.check} typeVal={'check'} setVal={d=>setWndData({...wndData,check:d})} width1='172' width2='15' />
                </div>
                <div className='reportContent' style={{position:'relative'}}>{content}{btn2}</div>
            </div>
            {/*showRange*/}
        </div>
    )

}


export default RepForm496